import React, { useEffect, useState } from 'react'
import DashboardSummary from '../DashboardSummaryNew';
import DashboardGroupedBarChart from "../DashboardGroupedBarChart";
import DashboardTable from '../DashboardTable';
import callPostApi from "../../../requests/PostRequests";
import * as Constants from '../../../requests/URLConstants';
import * as tableHeaders from './ULLtableHeaders';
import moment from 'moment';
import * as DashboardUtils from '../DashboardUtils.js';
import TableToolbarDownload from '../../../common/TableToolbarDownload';
import * as DashboardConstants from '../DashboardConstants';
import { TableToolbar, TableToolbarContent, TableToolbarMenu, Checkbox } from 'carbon-components-react';
import axios from "axios";
import * as workspaces from '../../../config/WorkspaceConstants'

const ULLAutomationTrustIndex = (props) => {

    const [trustIndexSummaryData, setTrustIndexSummaryData] = useState([]);
    const [trustIndexSummmaryTableData, setTrustIndexSummmaryTableData] = useState([]);
    const [trustIndexSummmaryGraphData, setTrustIndexSummmaryGraphData] = useState([]);
    const [trustIndexSummaryLoading, setTrustIndexSummaryLoading] = useState(false);
    const [successRateByGeoTableData, setSuccessRateByGeoTableData] = useState([]);
    const [successRateByGeoLoading, setSuccessRateByGeoLoading] = useState([]);
    const [botSummaryReportData, setBotSummaryReportData] = useState([]);
    const [botSummaryReportDataLoading, setBotSummaryReportDataLoading] = useState(false);
    const [automataStartedOnTimeGraphData, setAutomataStartedOnTimeGraphData] = useState([]);
    const [automataStartedOnTimeTableData, setAutomataStartedOnTimeTableData] = useState([]);
    const [automataStartedOnTimeLoading, setAutomataStartedOnTimeLoading] = useState(false);
    const [automataRunsOnTimeGraphData, setAutomataRunsOnTimeGraphData] = useState([]);
    const [automataRunsOnTimeTableData, setAutomataRunsOnTimeTableData] = useState([]);
    const [automataRunsOnTimeLoading, setAutomataRunsOnTimeLoading] = useState(false);
    const [FilteredTableHeaders, setFilteredTableHeaders] = useState([]);

    useEffect(() => {
        getTrustIndexSummary(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getBotSummaryByGeo(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getBotSummary(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getAutomataStartedOnTime(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getAutomataRunsOnTime(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged]);

    const getTrustIndexSummaryData = (param, TotalNoOfBots) => {
        let summary = [
            {
                title: DashboardConstants.AverageSuccessRate + '(%)',
                value: param.avgSucessRate
            },
            {
                title: DashboardConstants.TotalRuns,
                value: param.runs
            },
            {
                title: DashboardConstants.Completions,
                value: param.completions
            },
            {
                title: DashboardConstants.Terminations,
                value: param.termination
            },
            {
                title: DashboardConstants.TotalNoOfBots,
                value: TotalNoOfBots
            }
        ];
        setTrustIndexSummaryData(summary);
    };

    const prepareResourceUtilizationData = (response) => {
        let tableData = [];
        let tableObj = {};
        let graphData = [];
        let graphObj = {};
        let buckets = [];
        let successRate;
        if (response?.aggregations) {
            buckets = response?.aggregations?.priority?.buckets || [];
            for (let i = 0; i < buckets.length; i++) {
                let scheduleMisses = buckets[i]?.SchdMiss?.value || 0;
                let completions = buckets[i]?.Completions?.value || 0;
                let stopped = buckets[i]?.Stopped?.value || 0;
                let terminations = (buckets[i]?.Term?.value || 0) - scheduleMisses;
                tableObj = {
                    id: (i + 1).toString(),
                    priority: buckets[i].key,
                    totalCompletions: completions,
                    schMisses: scheduleMisses,
                    terminations: terminations
                }
                let totalRuns = completions + terminations + stopped;
                let failures = scheduleMisses + terminations;
                let rerunsValue = buckets[i]?.ReRuns?.value || 0;

                let reRuns = rerunsValue > failures ? failures : ((rerunsValue == totalRuns) ? 0 : rerunsValue);
                tableObj.executions = totalRuns;
                tableObj.reruns = reRuns;
                tableObj.successRate = completions ? ((completions * 100 / (totalRuns - reRuns + scheduleMisses)).toFixed(2)) + '%' : '0.00%';
                successRate = tableObj.successRate !== 0 ? tableObj?.successRate?.replace("%", '') : 0;
                graphObj = {
                    group: buckets[i].key,
                    key: buckets[i].key,
                    value: successRate ? successRate : 0
                };
                tableData.push(tableObj);
                graphData.push(graphObj);
            }
        }
        return { tableData, graphData };
    };

    const getTrustIndexSummary = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setTrustIndexSummaryLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETAUTOMATIONTRUSTINDEXSUMMARY, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response => {
                    formattedData = prepareResourceUtilizationData(response);
                    setTrustIndexSummmaryTableData(formattedData.tableData);
                    setTrustIndexSummmaryGraphData(formattedData.graphData);
                    setTrustIndexSummaryLoading(false);
                }).catch((error) => {
                    setTrustIndexSummaryLoading(false);
                });
        }
    }

    const prepareSuccessRateByGeoData = (response) => {
        let tableData = [];
        let tableObj = {};
        let buckets = [];
        let statusBucket = [];
        let expandedTable = [], expandedItemObj = {};
        let comments, failure, reRuns, expandedComments, totalRuns = 0;
        let executionTotal = 0, completionTotal = 0, stoppedTotal = 0, rerunTotal = 0, schmissesTotal = 0,
            terminationsTotal = 0, successRatetotal = 0, rerunfieldTotal = 0;
        if (response?.aggregations) {
            buckets = response?.aggregations?.geography?.buckets || [];
            for (let i = 0; i < buckets.length; i++) {
                rerunfieldTotal = 0;
                successRatetotal = 0;
                completionTotal = 0;
                stoppedTotal = 0;
                rerunTotal = 0;
                schmissesTotal = 0;
                terminationsTotal = 0;
                executionTotal = 0
                expandedTable = [];
                tableObj = {
                    id: (i + 1).toString(),
                    geo: buckets[i].key,
                }
                statusBucket = buckets[i]?.process_criticality?.buckets || [];
                for (let j = 0; j < statusBucket.length; j++) {
                    let terminations = (statusBucket[j]?.Term?.value || 0) - (statusBucket[j]?.SchedulerMiss?.value || 0);
                    let rerunsValue = (statusBucket[j]?.ReRuns?.value || 0);
                    let completions = (statusBucket[j]?.Completions?.value || 0);
                    let stopped = (statusBucket[j]?.Stopped?.value || 0);
                    let schedulerMiss = (statusBucket[j]?.SchedulerMiss?.value || 0);

                    terminationsTotal = terminationsTotal + terminations;
                    rerunfieldTotal = rerunfieldTotal + rerunsValue
                    completionTotal = completionTotal + completions;
                    stoppedTotal = stoppedTotal + stopped;
                    schmissesTotal = schmissesTotal + schedulerMiss;

                    failure = schedulerMiss + terminations;
                    totalRuns = completions + terminations + stopped;

                    expandedItemObj = {
                        id: j + 1,
                        geo: statusBucket[j].key,
                        geography: buckets[i].key,
                        completions: completions,
                        stopped: stopped,
                        schMisses: schedulerMiss,
                        terminations: terminations
                    }
                    expandedItemObj.executions = totalRuns;
                    executionTotal = executionTotal + totalRuns;
                    let failures = (schmissesTotal + terminationsTotal);
                    if (rerunfieldTotal > failures) {
                        expandedComments = 'Rerun > Failures';
                    }
                    else if (rerunfieldTotal == executionTotal) {
                        expandedComments = 'Rerun = Total Run';
                    }
                    else if (rerunfieldTotal < failures) {
                        expandedComments = 'Rerun < Failures';
                    }
                    else if (rerunfieldTotal == failures) {
                        expandedComments = 'Rerun = Failures';
                    }
                    else {
                        expandedComments = '-';
                    }
                    reRuns = rerunsValue > failure ? failure : ((totalRuns == rerunsValue) ? 0 : rerunsValue);
                    successRatetotal = (successRatetotal + (completions ? ((completions / (totalRuns - reRuns + schedulerMiss)) * 100) : 0));
                    expandedItemObj.comments = expandedComments;
                    expandedItemObj.reruns = reRuns ? reRuns : 0;
                    expandedItemObj.successRate = completions ? (((completions / (totalRuns - reRuns + schedulerMiss)) * 100).toFixed(2) + "%") : (0).toFixed(2) + "%";
                    rerunTotal = rerunTotal + reRuns;
                    expandedTable.push(expandedItemObj);
                    tableObj.expandedItems = expandedTable;
                }
                tableObj.executions = executionTotal;
                tableObj.completions = completionTotal;
                tableObj.stopped = stoppedTotal;
                tableObj.reruns = rerunTotal;
                tableObj.schMisses = schmissesTotal;
                tableObj.terminations = terminationsTotal;
                tableObj.successRate = (successRatetotal / statusBucket.length).toFixed(2) + '%';

                let failuresTotal = schmissesTotal + terminationsTotal;
                if (rerunfieldTotal > failuresTotal) {
                    comments = 'Rerun > Failures';
                }
                else if (rerunfieldTotal == executionTotal) {
                    comments = 'Rerun = Total Run';
                }
                else if (rerunfieldTotal < failuresTotal) {
                    comments = 'Rerun < Failures';
                }
                else if (rerunfieldTotal == failuresTotal) {
                    comments = 'Rerun = Failures';
                }
                else {
                    comments = '-';
                }
                tableObj.comments = comments;
                tableData.push(tableObj);
            }
        }
        return { tableData };
    };

    const getBotSummaryByGeo = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setSuccessRateByGeoLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETBOTSUMMARYBYGEO, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response => {
                    formattedData = prepareSuccessRateByGeoData(response);
                    setSuccessRateByGeoTableData(formattedData.tableData);
                    setSuccessRateByGeoLoading(false);
                }).catch((error) => {
                    setSuccessRateByGeoLoading(false);
                });
        }
    }

    const replaceEscapeCharacter = (val) => {
        val = val || "";
        let string = val?.toString()?.replace(/\n/g, "")?.replace(/\\n/g, "")?.replace(/\t/g, "")?.trim() || "";
        return string;
    }

    const prepareBotSummaryReportData = (response) => {
        let tableObj = {};
        let tableData = [];
        let reRuns, comments;

        let avgSucessRate = 0, runs = 0, TotalCompletions = 0, totalTerminations = 0, totalReruns = 0, totalSchedulerMisses = 0;
        let summaryData = { avgSucessRate: avgSucessRate, runs: runs, completions: TotalCompletions, termination: totalTerminations };

        if (response?.aggregations) {
            let buckets = response?.aggregations.BOTID.buckets;
            for (let i = 0; i < buckets.length; i++) {
                let scheduleMisses = buckets[i]?.SchedulerMisses?.value || 0;
                let rerunsValue = buckets[i]?.ReRuns?.value || 0;
                let completions = buckets[i]?.Completions?.value || 0;
                let stopped = buckets[i]?.Stopped?.value || 0;
                let termination = (buckets[i]?.Terminations?.value || 0) - scheduleMisses;
                let totalRuns = completions + termination + stopped;
                tableObj = {
                    id: (i + 1).toString(),
                    botId: replaceEscapeCharacter(buckets[i]?.key || ''),
                    leadPlatform: replaceEscapeCharacter(buckets[i]?.LeadPlatform?.hits?.hits?.[0]?.fields?.["busn_competency_name.keyword"]?.[0] || ''),
                    subArea: replaceEscapeCharacter(buckets[i]?.SubArea?.hits?.hits?.[0]?.fields?.["busn_component_name.keyword"]?.[0] || ''),
                    processName: replaceEscapeCharacter(buckets[i]?.ProcessName?.hits?.hits?.[0]?.fields?.["busn_srvc_name.keyword"]?.[0] || ''),
                    geo: replaceEscapeCharacter(buckets[i]?.Geography?.hits?.hits?.[0]?.fields?.["geo_name.keyword"]?.[0] || ''),
                    processCritical: replaceEscapeCharacter(buckets[i]?.ProcessCriticality?.hits?.hits?.[0]?.fields?.priority?.[0] || ''),
                    requestedBy: replaceEscapeCharacter(buckets[i]?.Requestedby?.hits?.hits?.[0]?.fields?.["busn_srvc_task_name.keyword"]?.[0] || ''),
                    deliveryModel: replaceEscapeCharacter(buckets[i]?.DeliveryModel?.hits?.hits?.[0]?.fields?.["srvc_sub_prc_name.keyword"]?.[0] || ''),
                    supportStatus: replaceEscapeCharacter(buckets[i]?.SupportStatus?.hits?.hits?.[0]?.fields?.["lfcl_stg.keyword"]?.[0] || ''),
                    completions: replaceEscapeCharacter(completions),
                    stopped: replaceEscapeCharacter(stopped),
                    schMisses: replaceEscapeCharacter(scheduleMisses),
                    terminations: replaceEscapeCharacter(termination),
                    lastRunStartTime: replaceEscapeCharacter(buckets[i]?.LastRunStartTime?.hits?.hits?.[0]?.fields?.["automata_start_time"]?.[0] || ''),
                    runStatus: replaceEscapeCharacter(buckets[i]?.LastRunStatus?.hits?.hits?.[0]?.fields?.["automata_status.keyword"]?.[0] || ''),
                    countOfOpenIncidents: replaceEscapeCharacter(buckets[i]?.OpenIncidentCount?.value || 0)
                }

                let failures = scheduleMisses + termination;
                reRuns = rerunsValue > failures ? failures : ((totalRuns == rerunsValue) ? 0 : rerunsValue);

                if (buckets[i].ReRuns.value > failures) {
                    comments = 'Rerun > Failures';
                }
                else if (buckets[i].ReRuns.value == totalRuns) {
                    comments = 'Rerun = Total Run';
                }
                else if (buckets[i].ReRuns.value < failures) {
                    comments = 'Rerun < Failures';
                }
                else if (buckets[i].ReRuns.value == failures) {
                    comments = 'Rerun = Failures';
                }
                else {
                    comments = '-';
                }

                tableObj.totalRuns = totalRuns;
                tableObj.reruns = reRuns;
                totalSchedulerMisses = totalSchedulerMisses + scheduleMisses
                runs = runs + totalRuns;
                TotalCompletions = TotalCompletions + completions;
                totalTerminations = totalTerminations + termination;
                totalReruns = totalReruns + reRuns
                tableObj.successRate = completions ?
                    (((completions / (totalRuns - reRuns + scheduleMisses)) * 100).toFixed(2)) + '%' : '0.00%';
                tableObj.comments = replaceEscapeCharacter(comments);
                tableData.push(tableObj);
            }
        }
        avgSucessRate = (TotalCompletions / (runs - totalReruns + totalSchedulerMisses)) * 100;
        summaryData = { avgSucessRate: avgSucessRate ? (avgSucessRate.toFixed(2) + '%') : 0, runs: runs, completions: TotalCompletions, termination: totalTerminations, reRuns: totalReruns };
        return { tableData, summaryData };
    };

    const getBotSummary = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotSummaryReportDataLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            axios.all([
                callPostApi(Constants.GETBOTSUMMARY, {
                    'Content-Type': 'application/json'
                }, bodyJSON)
                    .then(response => {
                        formattedData = prepareBotSummaryReportData(response);
                        setBotSummaryReportData(formattedData.tableData);
                        return formattedData.summaryData;
                    }),
                callPostApi(Constants.GETONBOARDEDBOTS, {
                    'Content-Type': 'application/json'
                }, bodyJSON)
                    .then(resp2 => {
                        if (resp2?.aggregations) {
                            let botsData = resp2?.aggregations.onboarded_bots.value;
                            return botsData;
                        }
                    })
            ])
                .then(axios.spread((summaryData, TotalNoOfBots) => {
                    getTrustIndexSummaryData(summaryData, TotalNoOfBots);
                    setBotSummaryReportDataLoading(false);
                })).catch((error) => {
                    setBotSummaryReportDataLoading(false);
                });
        }
    }

    const prepareAutomataStartedOnTimeData = (response) => {
        let graphObj = {};
        let graphData = [];
        let tableObj = {};
        let tableData = [];
        let totalRuns;

        if (response?.aggregations) {
            let buckets = response?.aggregations.priority.buckets;
            for (let i = 0; i < buckets.length; i++) {
                let SchedulerMisses = buckets[i].SchedulerMisses.value ? buckets[i].SchedulerMisses.value : 0;
                let Reruns = buckets[i].Reruns.value ? buckets[i].Reruns.value : 0;
                totalRuns = buckets[i].doc_count - Reruns;
                graphObj = {
                    group: buckets[i].key,
                    key: buckets[i].key,
                    value: ((totalRuns - SchedulerMisses) / totalRuns) * 100
                }
                tableObj = {
                    id: (i + 1).toString(),
                    priority: buckets[i].key,
                    scheduleMisses: SchedulerMisses,
                    totalRuns: totalRuns,
                    startedOnTime: totalRuns - SchedulerMisses,
                    startedOnTimePercentage: (((totalRuns - SchedulerMisses) / totalRuns) * 100).toFixed(2) + "%"
                }
                graphData.push(graphObj);
                tableData.push(tableObj);
            }
        }
        return { graphData, tableData };
    };

    const getAutomataStartedOnTime = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setAutomataStartedOnTimeLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETAUTOMATASTARTEDONTIME, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response => {
                    formattedData = prepareAutomataStartedOnTimeData(response);
                    setAutomataStartedOnTimeGraphData(formattedData.graphData);
                    setAutomataStartedOnTimeTableData(formattedData.tableData);
                    setAutomataStartedOnTimeLoading(false);
                }).catch((error) => {
                    setAutomataStartedOnTimeLoading(false);
                });
        }
    }

    const prepareAutomataRunsOnTimeData = (response) => {
        let graphObj = {};
        let graphData = [];
        let tableObj = {};
        let tableData = [];
        let totalExecution = 0;

        if (response?.aggregations) {
            let buckets = response?.aggregations.priority.buckets;
            for (let i = 0; i < buckets.length; i++) {
                totalExecution = buckets[i].doc_count ? buckets[i].doc_count : 0;
                let Longruncount = buckets[i].Longruncount.value ? buckets[i].Longruncount.value : 0
                graphObj = {
                    group: buckets[i].key,
                    key: buckets[i].key,
                    value: ((totalExecution - Longruncount) / totalExecution) * 100
                }
                tableObj = {
                    id: (i + 1).toString(),
                    priority: buckets[i].key,
                    totalRuns: totalExecution,
                    runOnTime: totalExecution - Longruncount,
                    runOnTimePercentage: (((totalExecution - Longruncount) / totalExecution) * 100).toFixed(2) + '%'
                }
                graphData.push(graphObj);
                tableData.push(tableObj);
            }
        }
        return { graphData, tableData };
    };

    const getAutomataRunsOnTime = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setAutomataRunsOnTimeLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETAUTOMATARUNSONTIME, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response => {
                    formattedData = prepareAutomataRunsOnTimeData(response);
                    setAutomataRunsOnTimeGraphData(formattedData.graphData);
                    setAutomataRunsOnTimeTableData(formattedData.tableData);
                    setAutomataRunsOnTimeLoading(false);
                }).catch((error) => {
                    setAutomataRunsOnTimeLoading(false);
                });
        }
    }

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority,
                    "status": dashboardFilterSelectionsAutomation.status,
                    "automata_state": dashboardFilterSelectionsAutomation.automata_state,
                    "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
                    "bot_id": dashboardFilterSelectionsAutomation.bot_id,
                    "buisness_component": dashboardFilterSelectionsAutomation.buisness_component,
                    "process_name": dashboardFilterSelectionsAutomation.process_name
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }
        return bodyJSON;
    };
    let BotSummaryHeaders = [...tableHeaders.botSummaryReportTableHeaders];
    const manageBotSummaryHeader = (checked, id) => {
        BotSummaryHeaders.forEach(header => {
            if (header.key === id) {
                header.hidden = !checked;
            }
        });
        let filteredheader = BotSummaryHeaders.filter(header => header.hidden === false);
        setFilteredTableHeaders(filteredheader);
    };
    return (
        <div className="top-margin dashboard">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={trustIndexSummaryLoading} summary={trustIndexSummaryData} title={DashboardConstants.AutomationTrustIndexSummary} />
                </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                        <div>{DashboardConstants.DetailedView}</div>
                    </div>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.BotSummaryReport}</div>
                            <div className="table-toolbar">
                                <TableToolbar>
                                    <TableToolbarContent>
                                        <TableToolbarMenu light iconDescription="Headers">
                                            <fieldset className="optional-headers">
                                                {BotSummaryHeaders.map(header => (header.optional ? <Checkbox labelText={header.header} checked={!header.hidden} onChange={manageBotSummaryHeader} id={header.key} /> : null))}
                                            </fieldset>
                                        </TableToolbarMenu>
                                        <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={botSummaryReportData} headers={tableHeaders.botSummaryReportTableHeaders} title={DashboardConstants.BotSummaryReport} filename={DashboardConstants.BotSummaryReportFileName} label={DashboardConstants.Download} />
                                    </TableToolbarContent>
                                </TableToolbar>
                            </div>
                        </div>
                        <div className="bold-border-table nested-table">
                            <DashboardTable loading={botSummaryReportDataLoading} rows={botSummaryReportData}
                                headers={FilteredTableHeaders.length ? FilteredTableHeaders : BotSummaryHeaders.filter(header => header.hidden === false)} showPagination={true} isSortingAllowed={true}
                            />
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="tile-view">
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={trustIndexSummaryLoading}
                                    title={DashboardConstants.TrustIndexSummary}
                                    graphAxesTitle={DashboardConstants.SuccessRate}
                                    graphBottomTitle={DashboardConstants.Priority}
                                    groupedBarChartData={trustIndexSummmaryGraphData}
                                    isPercentage={true}
                                />
                            </div>
                            <div className="report-container">
                                <DashboardTable loading={trustIndexSummaryLoading} rows={trustIndexSummmaryTableData} headers={tableHeaders.trustIndexSummaryTableHeaders}
                                    showPagination={true} isSortingAllowed={true} />
                            </div>
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.SuccessRateByGeo}</div>
                            <div className="download-button">
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={successRateByGeoTableData} headers={tableHeaders.successRateTableHeaders} title={DashboardConstants.SuccessRateByGeo} filename={DashboardConstants.SuccessRateFileName} label={DashboardConstants.Download} />
                            </div>
                        </div>
                        <div className="bold-border-table nested-table">
                            <DashboardTable loading={successRateByGeoLoading} rows={successRateByGeoTableData}
                                headers={tableHeaders.successRateTableHeaders} showPagination={true} isSortingAllowed={true} isExpandable={true}
                            />
                        </div>
                    </section>

                    <section className="border-bottom">
                        <div className="tile-view">
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={automataStartedOnTimeLoading}
                                    title={DashboardConstants.AutomataStartedOnTime}
                                    graphAxesTitle={DashboardConstants.StartedOnTime}
                                    graphBottomTitle={DashboardConstants.Priority}
                                    groupedBarChartData={automataStartedOnTimeGraphData}
                                    isPercentage={true}
                                />
                                <div className="bold-border-table">
                                    <DashboardTable loading={automataStartedOnTimeLoading} rows={automataStartedOnTimeTableData} headers={tableHeaders.automataStartedOnTimeTableHeaders}
                                        showPagination={true} isSortingAllowed={true} />
                                </div>
                            </div>
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={automataRunsOnTimeLoading}
                                    title={DashboardConstants.AutomataRunsOnTime}
                                    graphAxesTitle={DashboardConstants.RunsOnTime}
                                    graphBottomTitle={DashboardConstants.Priority}
                                    groupedBarChartData={automataRunsOnTimeGraphData}
                                    isPercentage={true}
                                />
                                <div className="bold-border-table">
                                    <DashboardTable loading={automataRunsOnTimeLoading} rows={automataRunsOnTimeTableData} headers={tableHeaders.automataRunsOnTimeTableHeaders}
                                        showPagination={true} isSortingAllowed={true} />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default ULLAutomationTrustIndex;
